import SecondaryNav from "../UI/SecondaryNav/SecondaryNav";
import Universities from "./Universities/Universities";
import classes from "./CountryDetail.module.scss";
import HeroSection from "./HeroSection/HeroSection";
import Overview from "./Overview/Overview";
import Courses from "./Courses/Courses";
import CostToStudy from "./CostToStudy/CostToStudy";
import Scholarships from "./Scholarships/Scholarships";
import Intake from "./Intake/Intake";
import Elligibility from "./Elligibility/Elligibility";
import Exams from "./Exams/Exams";
import ApplicationRequirements from "./ApplicationRequirements/ApplicationRequirements";
import StudentVisa from "./StudentVisa/StudentVisa";
import CareerOutcomes from "./CareerOutcomes/CareerOutcomes";
import TopCities from "./TopCities/TopCities";
import QuickReels from "./QuickReels/QuickReels";
import TopAdmits from "./TopAdmits/TopAdmits";
import Testimonials from "./Testimonials/Testimonials";
import WhyChooseKC from "./WhyChooseKC/WhyChooseKC";
import Articles from "./Articles/Articles";
import FAQs from "./FAQs/FAQs";
import RelatedLinks from "./RelatedLinks/RelatedLinks";
import { useEffect, useState } from "react";
import { loadJotFormScript } from "../../utils/loadJotFormScript";
import Banner1 from "./Banner1/Banner1";
import Banner2 from "./Banner2/Banner2";
import Banner3 from "./Banner3/Banner3";
import Banner4 from "./Banner4/Banner4";
import useIsMobile from "../../hooks/useIsMobile";

const CountryDetail = (props: any) => {
  const isMobile = useIsMobile(1000);
  const [headerHeight, setHeaderHeight] = useState<number | null>(null);
  const countryData = props.pageData?.[0];
  const scholarshipsData = props.scholarshipsData?.[0];
  const intakeData = props.pageData?.[0]?.intakeSection ?? {};
  const blogsSectionData = props.pageData?.[0].blogsSection ?? {};
  const blogsData = props.blogsData ?? [];

  const handleSelectTab = (tab: string) => {};

  useEffect(() => {
    loadJotFormScript();
  }, []);

  return (
    <section className={classes["country-detail-container"]}>
      <HeroSection countryData={countryData} headerHeight={headerHeight} setHeaderHeight={setHeaderHeight} />
      {!isMobile ? (
        <div className={classes["page-body"]}>
          <div>
            <SecondaryNav items={countryData?.menuBar} onSelectTab={handleSelectTab} headerHeight={headerHeight} />
          </div>
          <div>
            <div className={classes["section-with-padding"]}>
              {countryData.overview && <Overview countryData={countryData} />}
              {countryData?.topUniversities && <Universities countryData={countryData} />}
              {countryData?.topCourses && <Courses countryData={countryData} />}
            </div>
            {countryData?.banner_1 && <Banner1 bannerData={countryData?.banner_1 ?? {}} />}
            {countryData?.costToStudySection && <CostToStudy countryData={countryData} />}
            {scholarshipsData && <Scholarships countryData={countryData} scholarshipsData={scholarshipsData} />}
            {intakeData && <Intake intakeData={intakeData} />}
            {countryData?.eligibility && <Elligibility countryData={countryData} />}
            {countryData?.banner_2 && <Banner2 countryData={countryData} />}
            {countryData?.examSection && <Exams countryData={countryData} />}
            {countryData?.requirements && <ApplicationRequirements countryData={countryData} />}
            {countryData?.studentVisa && <StudentVisa countryData={countryData} />}
            {countryData?.careerOutcomes && <CareerOutcomes countryData={countryData} />}
            {countryData?.banner_3 && <Banner3 bannerData={countryData?.banner_3 ?? {}} />}
            {countryData?.studentFriendlyCities && <TopCities countryData={countryData} />}
            {countryData?.quickReels && <QuickReels countryData={countryData} />}
            {countryData?.banner_4 && <Banner4 bannerData={countryData?.banner_4 ?? {}} />}
            {countryData?.topAdmits && <TopAdmits countryData={countryData} />}
            {countryData?.videoTestimonial && <Testimonials countryData={countryData} />}
            {countryData?.whyChooseKc && <WhyChooseKC countryData={countryData} />}
            {blogsData && <Articles countryData={countryData} blogsData={blogsData} blogsSectionData={blogsSectionData} />}
            {countryData?.faq && <FAQs countryData={countryData} />}
            {countryData?.importantLinksSection && <RelatedLinks countryData={countryData} />}
          </div>
        </div>
      ) : (
        <>
          <SecondaryNav items={countryData?.menuBar} onSelectTab={handleSelectTab} headerHeight={headerHeight} />
          {countryData.overview && <Overview countryData={countryData} />}
          {countryData?.topUniversities && <Universities countryData={countryData} />}
          {countryData?.topCourses && <Courses countryData={countryData} />}
          {countryData?.banner_1 && <Banner1 bannerData={countryData?.banner_1 ?? {}} />}
          {countryData?.costToStudySection && <CostToStudy countryData={countryData} />}
          {scholarshipsData && <Scholarships countryData={countryData} scholarshipsData={scholarshipsData} />}
          {intakeData && <Intake intakeData={intakeData} />}
          {countryData?.eligibility && <Elligibility countryData={countryData} />}
          {countryData?.banner_2 && <Banner2 countryData={countryData} />}
          {countryData?.examSection && <Exams countryData={countryData} />}
          {countryData?.requirements && <ApplicationRequirements countryData={countryData} />}
          {countryData?.studentVisa && <StudentVisa countryData={countryData} />}
          {countryData?.careerOutcomes && <CareerOutcomes countryData={countryData} />}
          {countryData?.banner_3 && <Banner3 bannerData={countryData?.banner_3 ?? {}} />}
          {countryData?.studentFriendlyCities && <TopCities countryData={countryData} />}
          {countryData?.quickReels && <QuickReels countryData={countryData} />}
          {countryData?.banner_4 && <Banner4 bannerData={countryData?.banner_4 ?? {}} />}
          {countryData?.topAdmits && <TopAdmits countryData={countryData} />}
          {countryData?.videoTestimonial && <Testimonials countryData={countryData} />}
          {countryData?.whyChooseKc && <WhyChooseKC countryData={countryData} />}
          {blogsData && <Articles countryData={countryData} blogsData={blogsData} blogsSectionData={blogsSectionData} />}
          {countryData?.faq && <FAQs countryData={countryData} />}
          {countryData?.importantLinksSection && <RelatedLinks countryData={countryData} />}
        </>
      )}
    </section>
  );
};

export default CountryDetail;
